import type { MouseEvent } from 'react';

const onClickJustStopPropagation = (e: MouseEvent<HTMLElement>) => e.stopPropagation();

export default onClickJustStopPropagation;
